import { render, staticRenderFns } from "./WebinarTehnic.vue?vue&type=template&id=701ba663&"
import script from "./WebinarTehnic.vue?vue&type=script&lang=js&"
export * from "./WebinarTehnic.vue?vue&type=script&lang=js&"
import style0 from "./WebinarTehnic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports